export enum UserType {
  'None' = 0,
  'Client' = 1,
  'Agent' = 2
}
